module.exports = __webpack_public_path__ + "static/media/logo_techcombank.6ee83287.svg";